import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import useUser from 'core/hooks/useUser';

import { Box } from 'core/ui/atoms';
import { PromoBanner } from 'onramp/ui/components';
import Header from 'onramp/ui/components/V2/OnrampHeader';
import Footer from 'core/ui/components/Footer';
import CutoffModal from 'onramp/ui/components/Cutoff/Modal';

function OrderManagementLayout(props) {
  const { promoBannerEnabled, inverse, disableProgress, children, fullHeight = false } = props;
  const { currentUser } = useUser();

  const isReorder = currentUser && currentUser.reorder;

  return useMemo(() => {
    return (
      <Main $fullHeight={fullHeight}>
        <MainContainer>
          <OnrampHeader disableProgress={disableProgress} inverse={inverse} />
          {promoBannerEnabled && <Banner disabled={isReorder} />}
          <Container>
            {children}
          </Container>
        </MainContainer>
        <Footer />
        {currentUser && <CutoffModal />}
      </Main>
    );
  }, [promoBannerEnabled, inverse, disableProgress, children, currentUser, isReorder, fullHeight]);
}

OrderManagementLayout.propTypes = {
  promoBannerEnabled: PropTypes.bool,
  inverse: PropTypes.bool,
  disableProgress: PropTypes.bool,
  children: PropTypes.node,
};

const Main = styled.main`
  background: #FFF;
  padding-bottom: 0px;
  ${(p) => p.theme.max('sm')`
    padding-bottom: ${(props) => props.$fullHeight ? '90px' : '0px'};
  `}
`;

const Container = styled(Box)`
  margin-top: 60px;
`;

const Banner = styled(PromoBanner)`
  position: relative;
  z-index: ${(p) => p.theme.zIndex.promoBanner};
`;

const MainContainer = styled.section`
  position: relative;
`;

const OnrampHeader = styled(Header)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${(p) => p.theme.layout.onramp.headerHeight};
  z-index: ${(p) => p.theme.zIndex.headerFixed};
`;

export default OrderManagementLayout;
